var _style, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumbusDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85 85",
    style: {
      enableBackground: "new 0 0 85 85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7BC4D2;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 42.5,
    cy: 42.5,
    r: 42.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.9,48.2L50,48.1c0,0,0,0,0,0c-0.5,0-1,0.4-1,0.9c0,0.1-0.1,1.2-0.8,1.5l-0.4-27.9c0-0.5-0.5-1-1-1h-0.5 c-0.5,0-1,0.4-1,1l0,3c-2.9-0.5-9.9-0.6-10.3,8.7c-0.2,5,3.4,11.4,7.7,13.3c0.9-0.9,1.8-0.7,2.3-0.5l-0.1,3.6h-9.4 c-0.8-0.2-2.4-0.9-2.5-1.8c0-0.5-0.5-0.9-1-0.9c0,0,0,0,0,0l-8.9,0.1c-0.3,0-0.5,0.1-0.7,0.3c-0.2,0.2-0.3,0.5-0.3,0.7l0.1,1.1 c0,0.5,0.4,0.9,1,0.9l3.3,0.1c0,0,0.8,0.2,1.2,2.2l0.1,0.6c0.4,3,1.2,7.9,9.5,8.7c1.7,0.2,4.7,0.4,8.1,0.4c6.4,0,13.9-0.9,14.6-5.1 c0.3-1.8,0.5-3,0.5-3.7c0-0.3,0.1-0.6,0.1-0.8c0,0,0.1,0,0.2-0.1c0.8-0.4,1.2-0.5,1.2-0.5c0.5,0,0.9-0.5,0.9-1v-2.9 C62.9,48.7,62.4,48.2,61.9,48.2z M41.4,34.7c1-6,2.7-7.9,3.9-8.5l-0.3,21C43.7,46.3,40,43,41.4,34.7z M60.9,51.3 c-0.3,0.1-0.6,0.2-1,0.4c-1.2,0.6-1.2,1.2-1.4,2.5c-0.1,0.7-0.2,1.8-0.5,3.6c-0.5,3-9,4.2-20.5,3.1c-6.8-0.7-7.3-4.1-7.7-7l-0.1-0.6 c-0.3-1.6-0.8-2.6-1.4-3.1l3.1,0c0.9,1.9,3.6,2.6,3.9,2.6c0.1,0,0.2,0,0.2,0h10.5h1.3h0.4c1.9,0,2.8-1.4,3.2-2.6l10,0V51.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumbusDay);
export default __webpack_public_path__ + "static/media/ColumbusDay.0ff335f2b9266bf348b1d41c28d6e9f3.svg";
export { ForwardRef as ReactComponent };